var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { joinClasses } from "../../../utils/Filters";
import { Tooltip } from "../05-atoms/Tooltip";
import { createPalleteStateClassName } from "../../../theme/Theme";
var TableRow = /** @class */ (function (_super) {
    __extends(TableRow, _super);
    function TableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showTooltip: false,
        };
        _this.showTooltip = _this.showTooltip.bind(_this);
        _this.hideTooltip = _this.hideTooltip.bind(_this);
        return _this;
    }
    TableRow.prototype.render = function () {
        var _this = this;
        var clazzName = joinClasses("scl-m-table__tr", !!this.props.even ? "scl-m-table__tr--even" : undefined, createPalleteStateClassName(this.props.themePalleteState));
        return (React.createElement(React.Fragment, null,
            !!this.props.rowData.tooltip && this.state && this.state.showTooltip ?
                React.createElement("tr", { className: "scl-m-table__tr", style: { height: "0", borderSpacing: "0" } },
                    React.createElement("td", { style: { padding: "0" }, colSpan: this.props.rowData.data.length, className: "scl-m-table__td" },
                        React.createElement(Tooltip, null, this.props.rowData.tooltip)))
                : null,
            React.createElement("tr", { className: clazzName, onMouseEnter: this.showTooltip, onMouseLeave: this.hideTooltip }, this.props.rowData.data.map(function (value, indexC) { return (React.createElement("td", { key: "tr-td-".concat(indexC), className: joinClasses("scl-m-table__td", ((indexC + 1 === _this.props.rowData.data.length && !!_this.props.hasActions)
                    ? "with-actions" : undefined), _this.props.dataColumns
                    && _this.props.dataColumns[indexC]
                    && !!_this.props.dataColumns[indexC].alignRight ? "align-right" : undefined) }, value || "")); }))));
    };
    TableRow.prototype.showTooltip = function () {
        this.setState({
            showTooltip: true,
        });
    };
    TableRow.prototype.hideTooltip = function () {
        this.setState({
            showTooltip: false,
        });
    };
    return TableRow;
}(React.Component));
export { TableRow };
